import { Box, Flex, keyframes } from '@gazin/ecommerce-ui'
import { FaSpinner } from 'react-icons/fa'
import { theme } from 'src/styles/themes/default'

export default function Carregando() {
  const spin = keyframes`
    from { transform: rotate(0deg) }
    to { transform: rotate(360deg) }
  `

  const animation = `${spin} infinite 2s linear`

  return (
    <Flex
      alignItems="center"
      bgColor="#00000066"
      flex="1"
      flexDirection="column"
      height="100%"
      justifyContent="center"
      left="0"
      overflow="hidden"
      position="fixed"
      top="0"
      width="100%"
      zIndex="500"
      data-testid="carregando"
    >
      <Box animation={animation}>
        <FaSpinner
          className="super-crazy-colors"
          color={theme.colors.white}
          size={'3em'}
          style={{ textShadow: '0 0.063rem 0 #0000001A' }}
        />
      </Box>
    </Flex>
  )
}
